import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import FormControl from "@material-ui/core/FormControl";
import { Cancel } from "@material-ui/icons";

import LoadProfile from "components/services/LoadProfile";
import LoadGender from "components/services/LoadGender";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function EditUser(props) {
  const classes = useStyles();

  const data = props.id;
  const [returnLogin, setReturnLogin] = React.useState(false);

  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [errorServer, setErrorServer] = useState(false);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    id: data.id,
    name: data.name,
    lastName: data.lastname,
    email: data.email,
    profile_id: data.profile_id,
    profilename: data.profilename,
    profiledata: { id: data.profile_id, name: data.profilename },
    gender_id: data.gender_id,
    gendername: data.gendername,
    genderdata: { id: data.gender_id, name: data.gendername },
    password: "",
    errorName: false,
    errorProfile: false,
    errorGender: false,
    errorEmail: false,
    errorLastName: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorName: false,
      errorEmail: false,
      errorLastName: false,
    });
    setOpenAlert(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setOpenAlert(false);
    setErrorServer(false);

    if (values.name.length === 0) {
      setValues({ ...values, errorName: true });
      setMensaje('El campo "Nombre" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.lastName.length === 0) {
      setValues({ ...values, errorLastName: true });
      setMensaje('El campo "Apellido" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.gendername.length === 0) {
      setValues({ ...values, errorGender: true });
      setMensaje('El campo "Género" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.profilename.length === 0) {
      setValues({ ...values, errorProfile: true });
      setMensaje('El campo "Profile" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.email.length === 0) {
      setValues({ ...values, errorEmail: true });
      setMensaje('El campo "Email" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else {
      const dataValue2 = {
        id: values.id,
        name: values.name,
        lastName: values.lastName,
        gender_id: values.gender_id,
        profile_id: values.profile_id,
        email: values.email,
        keyAplication: keyAplication,
      };

      if (values.password !== "") {
        dataValue2.password = values.password;
      }

      axios
        .post(`${urlServices}routes_usersupdate.php`, dataValue2, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data.code === 1) {
            setMensaje("Modificado con exito.");
            setOpenAlert(true);
            setError("success");
            props.callBackRefresh();
          } else if (response.data.code === 0) {
            setMensaje("Error al modificar.");
            setOpenAlert(true);
            setError("error");
          }
        })
        .catch((e) => {
          if (e.response.status === 401) {
            setTimeout(() => {
              localStorage.clear();
              setReturnLogin(true);
            }, 200);
          } else {
            setErrorServer(true);
          }
        });
    }
  };

  const changeProfile = (data) => {
    setValues({
      ...values,
      profile_id: data !== null ? data.id : "",
      profilename: data !== null ? data.name : "",
      profiledata: data !== null ? data : [],
      errorProfile: false,
    });
  };

  const changeGender = (data) => {
    setValues({
      ...values,
      gender_id: data !== null ? data.id : "",
      gendername: data !== null ? data.name : "",
      genderdata: data !== null ? data : [],
      errorGender: false,
    });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        style={{ zIndex: 100 }}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {errorServer ? (
                  <Alert severity="error">
                    Error al registrar en el servidor
                  </Alert>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <div className={classes.titleCardFilter}>
                      Editar usuario
                    </div>
                    <div className={classes.lineBottom}></div>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="name"
                        value={values.name}
                        error={values.errorName}
                        onChange={handleChange("name")}
                        fullWidth
                        required
                        label="Nombres"
                        margin="dense"
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="lastName"
                        value={values.lastName}
                        error={values.errorLastName}
                        onChange={handleChange("lastName")}
                        fullWidth
                        required
                        label="Apellidos"
                        margin="dense"
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadGender
                      refresh={changeGender}
                      value={values.genderdata}
                      error={values.errorGender}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadProfile
                      refresh={changeProfile}
                      value={values.profiledata}
                      error={values.errorProfile}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="email"
                      value={values.email}
                      onChange={handleChange("email")}
                      label="E-mail"
                      error={values.errorEmail}
                      fullWidth
                      required
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="password"
                      value={values.password}
                      onChange={handleChange("password")}
                      label="Contraseña"
                      fullWidth
                      type="password"
                      helperText="Si desea cambiar la contraseña, ingrese la nueva en este campo."
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <br></br>
                    <center>
                      <Button
                        type="submit"
                        className={classes.buttonSubmit}
                        onClick={submitForm}
                      >
                        Guardar
                      </Button>
                    </center>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Snackbar
              open={openAlert}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={handleClose}
            >
              <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
                <Alert
                  onClose={handleClose}
                  severity={error === "error" ? "error" : "success"}
                  elevation={6}
                  variant="filled"
                >
                  {mensaje}
                </Alert>
              </Slide>
            </Snackbar>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
